module.exports = __webpack_public_path__ + "static/media/stage-icon.fddcc1d0.svg";